import { useCancelDataChangeRequestMutation } from '../../../../../__generated__/graphql';
import { useNamespacedTranslation } from '../../../../../../../hooks/useNamespacedTranslation';
import { useToasts } from '../../../../../../../context/Toast';

export const useCancelChangeRequest = (onSuccess: () => void) => {
  const t = useNamespacedTranslation('changeRequests');
  const { addSuccess, addError } = useToasts();

  const [cancelRequest, { loading: isCanceling }] =
    useCancelDataChangeRequestMutation({
      onCompleted: () => {
        addSuccess(t('previewModal.cancelSuccess'));
        onSuccess();
      },
      onError: (error) => {
        addError(t('previewModal.cancelError'));
      },
      update: (cache, response, variables) => {
        if (!response.data || !variables) {
          return;
        }
        const changeRequestId = variables.variables?.id;
        const changeRequestCacheId = cache.identify({
          Id: changeRequestId,
          __typename: 'EmployeeDataChangeRequest',
        });
        cache.evict({
          id: changeRequestCacheId,
        });
        cache.gc();
      },
    });

  const handleCancel = async (id: string) => {
    await cancelRequest({
      variables: {
        id,
      },
    });
  };

  return {
    handleCancel,
    isCanceling,
  };
};
